import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { request } from "@/js/http/http_request.js";
import { getErrorData } from "@/js/forms.js";
import { formRules } from "@/js/form_rules.js";
import { listContinents } from "@/js/lists.ts";
import DefaultDeparturesComponent from "@/components/warehouse/DefaultDeparturesComponent";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
export default {
  name: "DefaultDeparturesPopin",
  components: {
    DefaultDeparturesComponent: DefaultDeparturesComponent,
    Confirm: Confirm
  },
  data: function data() {
    return {
      isLoading: false,
      dialog: false,
      tab: null,
      listCountries: [],
      listStates: [],
      continents: [],
      warehouses: [],
      defaultsDepartures: [],
      rules: formRules
    };
  },
  computed: {
    displayedCountries: function displayedCountries() {
      var _this$listCountries,
        _this$continents,
        _this2 = this;
      return ((_this$listCountries = this.listCountries) === null || _this$listCountries === void 0 ? void 0 : _this$listCountries.length) > 0 && ((_this$continents = this.continents) === null || _this$continents === void 0 ? void 0 : _this$continents.length) > 0 ? this.listCountries.filter(function (x) {
        var _this2$continents$_th;
        return x.continent_iso_2 == ((_this2$continents$_th = _this2.continents[_this2.tab]) === null || _this2$continents$_th === void 0 ? void 0 : _this2$continents$_th.iso);
      }) : [];
    },
    displayedDepartures: function displayedDepartures() {
      var _this$defaultsDepartu,
        _this$continents2,
        _this3 = this;
      return ((_this$defaultsDepartu = this.defaultsDepartures) === null || _this$defaultsDepartu === void 0 ? void 0 : _this$defaultsDepartu.length) > 0 && ((_this$continents2 = this.continents) === null || _this$continents2 === void 0 ? void 0 : _this$continents2.length) > 0 ? this.defaultsDepartures.filter(function (x) {
        var _this3$continents$_th;
        return x.continentIso2 == ((_this3$continents$_th = _this3.continents[_this3.tab]) === null || _this3$continents$_th === void 0 ? void 0 : _this3$continents$_th.iso);
      }) : [];
    }
  },
  created: function created() {
    var _this4 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this4.fetchContinents();
          case 2:
            _this4.fetchCountries();
            _context.next = 5;
            return _this4.fetchWarehouses();
          case 5:
            _this4.fetchDefaultDepartures();
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    open: function open() {
      var _this5 = this;
      this.dialog = true;
      return new Promise(function (resolve, reject) {
        _this5.resolve = resolve;
        _this5.reject = reject;
      });
    },
    close: function close() {
      this.dialog = false;
    },
    fetchWarehouses: function fetchWarehouses() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this = _this6;
              _context2.next = 3;
              return request("/v1/warehouses", "post", {
                paging: null
              }, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to load warehouses");
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
              });
            case 3:
              response = _context2.sent;
              if (response) {
                _this6.warehouses = response.data.warehouses;
              }
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    fetchCountries: function fetchCountries() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this = _this7;
              _context3.next = 3;
              return request("/v1/countries/protected?implantedMarket=true", "GET", null, true, "api").catch(function () {
                _this.$toasted.show("An error occured. Please contact an administrator.", {
                  type: "error"
                });
              });
            case 3:
              response = _context3.sent;
              if (response) {
                _this7.listCountries = _toConsumableArray(response.data.countries);
                _this7.listStates = _toConsumableArray(response.data.states);
                _this7.isLoading = true;
              }
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    fetchDefaultDepartures: function fetchDefaultDepartures() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this = _this8;
              _context4.next = 3;
              return request("/v1/warehouse/defaults-departures", "get", null, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to load defaults departures");
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
              });
            case 3:
              response = _context4.sent;
              if (response) {
                _this8.defaultsDepartures = response.data.map(function (x) {
                  var _this$warehouses$find;
                  return _objectSpread(_objectSpread({}, x), {}, {
                    warehouse_name: (_this$warehouses$find = _this.warehouses.find(function (y) {
                      return y.id_warehouse === x.warehouseId;
                    })) === null || _this$warehouses$find === void 0 ? void 0 : _this$warehouses$find.name
                  });
                });
              }
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    fetchContinents: function fetchContinents() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this = _this9;
              _context5.next = 3;
              return request("/v1/warehouse/defaults-departures/continents", "get", null, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to load continents");
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
                return;
              });
            case 3:
              response = _context5.sent;
              if (response) {
                response.data.forEach(function (continentIso) {
                  _this.continents.push({
                    iso: continentIso,
                    display_name: listContinents.find(function (x) {
                      return x.id === continentIso;
                    }).display_name
                  });
                });
                _this.continents.sort(function (a, b) {
                  return a.display_name.localeCompare(b.display_name);
                });
              }
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    }
  }
};